import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Quote } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const SlideBlock = ({ block, onDone }) => {
  const { t } = useLang();
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="card-dark p-7 sm:p-11" data-testid="academy-slide">
      <span className="badge-lime">{t("learn.theory")}</span>
      <h2 className="font-heading font-black text-2xl sm:text-4xl text-[#0B1B3A] mt-5 leading-tight" data-testid="academy-slide-title">
        {block.title}
      </h2>
      <ul className="mt-8 space-y-4" data-testid="academy-slide-bullets">
        {(block.bullets || []).map((b, i) => (
          <motion.li
            key={b}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 + i * 0.08 }}
            className="flex items-start gap-4"
          >
            <span className="w-7 h-7 rounded-full bg-[#1D4ED8] text-white text-xs font-heading font-black flex items-center justify-center shrink-0 mt-0.5">
              {i + 1}
            </span>
            <span className="text-base text-[#1E293B] font-semibold leading-relaxed">{b}</span>
          </motion.li>
        ))}
      </ul>
      {block.image_url && (
        <img src={block.image_url} alt={block.title} className="w-full rounded-[22px] border border-[#E2E8F0] mt-8 object-cover max-h-[320px]" />
      )}
      {block.note && (
        <div className="mt-8 rounded-[22px] bg-[#EEF4FF] p-6" data-testid="academy-slide-note">
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-[#1D4ED8]">
            <Quote className="w-3.5 h-3.5" /> {t("academy.coachNote")}
          </p>
          <p className="text-sm text-[#0B1B3A] font-semibold mt-3 leading-relaxed">{block.note}</p>
        </div>
      )}
      <button data-testid="academy-slide-next" onClick={() => onDone(true)} className="btn-blue mt-9">
        {t("academy.nextSlide")} <ArrowRight className="w-4 h-4" />
      </button>
    </motion.div>
  );
};

export default SlideBlock;
